import script from "./SummaryReportCommunityProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryReportCommunityProgress.vue?vue&type=script&setup=true&lang=js"

import "./SummaryReportCommunityProgress.vue?vue&type=style&index=0&id=1980824a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1980824a"]])

export default __exports__